<template>
  <footer id="footer">
    <div class="inner">
      <h1 class="logo">
        <router-link to="/Main">
          <div class="flogoImg"></div>
        </router-link>
      </h1>
      <article>
        <ul class="top">
          <li>
            <a href="https://www.2000fmc.or.kr/ic-kr/cntnts/i-144/web.do" target="_blank" title="개인정보처리방침"><b>개인정보처리방침</b></a>
          </li>
          <li>
            <button title="이메일수집거부" @click="modalShowBtn('emailModalShow')">이메일무단수집거부</button>
          </li>
          <li>
            <button title="저작권보호정책" @click="modalShowBtn('copyrightModalShow')">저작권보호정책</button>
          </li>
        </ul>
        <address>
          <ul>
            <li>경기 이천시 서희로 11 업무센터 1동 이천시 시설관리공단</li>
            <li>대표자: 이천시시설관리공단 이사장</li>
            <li>대표번호: 1899-0036</li>
            <li>사업자번호: 126-82-13384</li>
          </ul>
        </address>
        <p class="copyright">Copyright © 이천시통합주차포털 All rights reserved.</p>
      </article>
      <div class="famSelect">
        <label for="familySite" class="hidden">이천시 패밀리 사이트</label>
        <select
          id=""
          @change="goFamilySite($event)"
          @keydown.up="eventStem($event)"
          @keydown.right="eventStem($event)"
          @keydown.down="eventStem($event)"
          @keydown.left="eventStem($event)"
        >
          <option value="" selected>FAMILY SITE</option>
          <option value="https://www.mois.go.kr/frt/a01/frtMain.do">행정안전부</option>
          <option value="https://www.gg.go.kr/#Home">경기도</option>
          <option value="https://www.icheon.go.kr/intropage/index.html">이천시</option>
          <option value="https://council.icheon.go.kr/">이천시의회</option>
          <option value="https://2000farmpark.or.kr/">이천농업테마공원</option>
          <option value="https://www.2000happydream.or.kr/main/main.do?mnr=main">이천시교통약자이동지원센터</option>
          <option value="https://www.cleaneye.go.kr/">지방공기업 클린아이</option>
          <option value="https://job.cleaneye.go.kr/">지방공공기관 통합채용정보공개시스템</option>
          <option value="https://www.clean.go.kr/index.es?sid=a1">청렴포털 부패공익신고</option>
          <option value="https://www.acrc.go.kr/">국민권익위원회</option>
          <option value="https://www.open.go.kr/com/main/mainView.do">정보공개포털</option>
        </select>
      </div>
    </div>

    <Modal v-if="emailModalShow">
      <template #info> 이메일무단수집거부 </template>
      <template #content>
        <article>
          <div class="terms">
            <p>
              이천시시설관리공단에 게시된 이메일 주소가 전자우편 수집프로그램이나 그 밖의 기술적 장치를 이용하여
              무단으로 수집되는 것을 거부하며, 이를 위반 시 정보통신망 이용 촉진 및 정보보호 등에 관한 법률 등에 의해
              처벌받을 수 있습니다.
            </p>
          </div>
        </article>
      </template>
      <template #button>
        <button class="btn closeBtn" @click="modalCloseBtn('emailModalShow')"><span class="hidden">닫기</span></button>
      </template>
    </Modal>

    <Modal v-if="personalModalShow">
      <template #info> 개인정보처리방침 </template>
      <template #content>
        <article>
          <div class="terms">
            <strong
              >이천시시설관리공단은 정보주체의 자유와 권리 보호를 위해 「개인정보 보호법」 및 관계 법령이 정한 바를
              준수하여, 적법하게 개인정보를 처리하고 안전하게 관리하고 있습니다. 이에 「개인정보 보호법」 제30조에 따라
              정보주체에게 개인정보 처리에 관한 절차 및 기준을 안내하고, 이와 관련한 고충을 신속하고 원활하게 처리할 수
              있도록 하기 위하여 다음과 같이 개인정보 처리방침을 수립·공개합니다.</strong
            >
            1. 개인정보의 처리목적
            <br />
            ① 이천시시설관리공단은 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적
            이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 「개인정보 보호법」 제18조에 따라 별도의
            동의를 받는 등 필요한 조치를 이행할 예정입니다.<br />

            가. 회원 가입 및 관리회원 가입의사 확인, 회원제 서비스 제공에 따른 본인 식별·인증, 회원자격 유지·관리,
            제한적 본인확인제 시행에 따른 본인확인, 서비스 부정이용 방지, 만 14세 미만 아동의 개인정보 처리시
            법정대리인의 동의여부 확인, 각종 고지·통지 등을 목적으로 개인정보를 처리합니다.<br />
            나. 민원사무 처리<br />
            민원인의 신원 확인, 민원사항 확인, 사실조사를 위한 연락·통지, 처리결과 통보 등의 목적으로 개인정보를
            처리합니다.<br />
            다. 개인정보파일의 등록 및 공개<br />
            「개인정보 보호법」 제32조에 따라 등록·공개하는 개인정보파일의 처리목적·보유기간 및 항목은 아래와
            같습니다.<br />
            1. 공영주차장 주차요금 관리대장주차장법 제9조/미납주차요금 고지서 발송이름, 집주소, 기타(차량번호) 5년<br />
            2. 공영주차장월정기권 이용자 명부이천시 주차장 설치 및 관리 조례 / 월정기권 이용 고객 관리이름,
            핸드폰(연락처),기타(차량번호) 5년<br />
            3. 공영주차장 월정기권 차량변경 신청 관리대장이천시 주차장 설치 및 관리 조례/ 월정기권 이용 고객 관리이름,
            핸드폰(연락처),기타(차량번호) 5년<br />
            4. 공영주차장 월정기권 과오납/환급 신청 관리대장이천시 주차장설치 및 관리 조례/ 월정기권 이용 고객 관리이름,
            핸드폰(연락처),기타(차량번호), 계좌번호 5년<br />
            5. 납골당 및 공설 공원묘지 봉안관리 대장장사 등에 관한 법률시행규칙 제10조/ 납골당 및 묘지 관리이름, 집주소,
            집연락처,핸드폰(연락처), 주민번호(사망자) 준영구<br />
            6. 자연장 관리대장 장사 등에 관한 법률시행규칙 제10조/ 묘지, 분묘 등에 관한상황의 기록, 보관이름, 집주소,
            집연락처,핸드폰(연락처), 주민번호(사망자) 준영구<br />
            7. 이천농업테마공원 대관허가 신청관리대장 이천시 농업테마공원운영 조례 / 이천농업테마공원 시설물 대관등
            서비스 제공이름, 직장주소, 직장연락처,핸드폰(연락처), 생년월일 5년<br />
            8. 이천농업테마공원숙박이용자명단 이천시 농업테마공원운영 조례 / 이천농업테마공원 숙박 이용 고객 관리성명,
            연락처, 이메일, 생년월일, 주소(할인 시), 통장사본(환불 시) 3년<br />
            9. 이천농업테마공원체험예약현황 이천시 농업테마공원운영 조례 / 효율적인체험운영 관리성명, 연락처 3년<br />
            10. 이천시 교통약자이동지원센터 심사승인처리부 교통약자 이동편의 증진법제16조 / 교통약자 이동지원센터 이용
            회원 관리이름, 집주소, 집연락처,핸드폰(연락처), 생년월일,기타(성별, 장애유형 및 등급) 준영구<br />
            11. 이천시 교통약자이동지원센터 이용대상자관리 교통약자 이동편의 증진법제16조 / 교통약자 이동지원센터 이용
            회원 관리이름, 집주소, 집연락처,핸드폰(연락처), 생년월일,기타(성별, 장애유형 및 등급) 준영구<br />
            12. 이천시 교통약자이동지원센터 요청서 이천시 교통약자의 이동편의 증진에 관한 업무지침 제7조/이용대상자 관리
            등이름, 집주소, 핸드폰(연락처),생년월일 준영구<br />
            <br /><br />
            2. 개인정보의 처리 및 보유기간
            <br />
            ① 이천시시설관리공단은 법령에 따른 개인정보 보유·이용 기간 또는 정보주체로부터 개인정보를 수집 시 동의 받은
            개인정보 보유·이용기간 내에서 개인정보를 처리합니다.<br /><br />
            ② 각각의 개인정보 처리 및 보유 기간은 다음과 같습니다.<br /><br />
            가. 홈페이지 회원 가입 및 관리: 홈페이지 탈퇴시까지 다만, 다음의 사유에 해당하는 경우에는 해당 사유
            종료시까지<br />
            1) 관계 법령 위반에 따른 수사·조사 등이 진행중인 경우에는 해당 수사, 조사 종료시까지<br />
            2) 홈페이지 이용에 따른 채권, 채무관계 잔존시에는 해당 채권, 채무관계 정산시까지<br />
            3) 3년 이상 미 접속 고객일 경우 개인정보 파기<br />
            4) 공단 홈페이지에서 운영하는 게시판에 본인확인을 통하여 작성된 글의 경우 게시글 삭제 시 즉시 파기<br /><br />
            나. 민원사무 처리: 민원처리 종료 후 3년<br /><br />
            다. 이천농업테마공원 숙박이용자명단, 이천농업테마공원 체험예약현황: 3년<br /><br />
            라. 공영주차장 주차요금 관리대장, 공영주차장 월정기권 이용자 명부, 공영주차장 월정기권 차량변경 신청
            관리대장, 공영주차장 월정기권 과오납/환급 신청 관리대장, 이천농업테마공원 대관허가 신청 관리대장: 5년<br /><br />
            마. 납골당 및 공설 공원묘지 봉안관리대장, 자연장 관리대장, 이천시 교통약자 이동지원센터 심사승인처리부,
            이천시 교통약자 이동지원센터 이용 대상자 관리, 이천시 교통약자 이동지원센터 요청서: 준영구<br /><br />
            <br /><br />
            3. 처리하는 개인정보의 항목
            <br />
            이천시시설관리공단은 다음의 개인정보 항목을 처리하고 있습니다.<br /><br />

            가. 이천시 교통약자 이동지원센터 홈페이지 회원 가입 및 관리<br />
            ＊ 필수항목: 성명, 생년월일, 아이디, 비밀번호, 주소, 전화번호, 휴대폰번호, 성별, 주소<br />
            ＊ 선택항목: 이메일주소<br /><br />
            나. 민원사무 처리<br />
            ＊ 필수항목: 성명, 전화번호<br />
            ＊ 선택항목: 이메일주소<br />
            (단, 홈페이지 내 민원사무 처리의 경우 전화번호를 필수항목으로 수집하지 않음)<br /><br />
            다. 인터넷 서비스 이용과정에서 아래 개인정보 항목이 자동으로 생성되어 수집될 수 있습니다. (자동으로
            생성·수집되는 개인정보항목이 있는 경우)<br />
            ＊ IP주소, 쿠키, MAC주소, 서비스 이용기록, 방문기록, 불량 이용기록<br />
            <br /><br />
            4. 개인정보파일 등록 현황
            <br />
            이천시시설관리공단이 「개인정보 보호법」 제32조에 따라 등록·공개하는 개인정보파일의 처리목적·보유기간 및
            항목은 아래와 같습니다.<br />

            개인정보파일의 처리목적·보유기간 및 항목은 개인정보파일의 특성에 따라 달리 규정하고 있으며, 개인정보파일별
            상세한 내용은 개인정보보호 종합포털을 통해 확인하여 주시기 바랍니다.<br />

            ▶ 개인정보보호위원회 개인정보보호 종합지원포털(www.privacy.go.kr) ▷ 개인정보민원 ▷ 개인정보 열람 등 요구 ▷
            개인정보파일 목록검색 “이천시시설관리공단”
            <br /><br />
            5. 개인정보의 제3자 제공<br />
            공단이 수집·보유하고 있는 개인정보는 이용자의 동이 없이 제3자에게 제공하지 않습니다. 공단이 통상적으로 다른
            기관에 제공하는 개인정보 현황은 없습니다.<br />
            <br /><br />
            6. 개인정보처리의 위탁<br />
            이천시시설관리공단은 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.<br />

            <br /><br />

            연번 부서 위탁받는 자(수탁자) 위탁업무<br />
            1 경영관리팀 ㈜이케이오스 (TEL.02-782-6745) 전산 네트워크 및 보안장비 유지관리<br />
            2 경영관리팀 ㈜아이엔씨솔루션 (TEL.02-6205-1701) 전자문서프로그램 및 복무관리시스템 유지관리<br />
            3 경영관리팀 씨앤에프시스템(주) (TEL.02-537-0514) ERP시스템 유지보수<br />
            4 경영관리팀 유비디에스(주) (TEL.02-2606-1525) 백업시스템 유지보수<br />
            5 경영관리팀 ㈜메일플러그 (TEL.1668-2590) 웹메일시스템 유지보수<br />
            6 공공사업팀 ㈜케이앤엘정보시스템 (TEL.02-454-1984) 주차장 운영관리시스템 유지보수<br />
            7 복지여가팀 ㈜상상을 만드는 사람들 (TEL.031-632-8651) 공단 및 농업테마공원 홈페이지 유지보수<br />
            8 교통사업팀 오롯소프트(주) (TEL.031-291-1208) 이동지원센터 관제시스템 유지보수<br />
            <br /><br />
            이천시시설관리공단은 위탁계약 체결 시 「개인정보 보호법」 제26조에 따라 위탁업무 수행목적 외 개인정보
            처리금지, 안전성 확보조치, 재위탁 제한, 수탁자에 대한 관리·감독, 손해배상 등 책임에 관한 사항을 계약서 등
            문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.<br />

            위탁업무의 내용이나 수탁자가 변경될 경우에는 지체없이 본 개인정보 처리방침을 통하여 공개하도록
            하겠습니다.<br />
            <br /><br />
            7. 개인정보의 파기<br />
            ① 이천시시설관리공단은 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는
            지체없이 해당 개인정보를 파기합니다.<br />

            ② 정보주체로부터 동의받은 개인정보 보유기간이 경과하거나 처리목적이 달성되었음에도 불구하고 다른 법령에 따라
            개인정보를 계속 보존하여야 하는 경우에는 해당 개인정보(또는 개인정보파일)를 별도의 데이터베이스(DB)로
            옮기거나 보관장소를 달리하여 보존합니다.<br />

            ③ 개인정보 파기의 절차 및 방법은 다음과 같습니다.<br />

            가. 파기절차<br />
            이천시시설관리공단은 파기하여야 하는 개인정보(또는 개인정보파일)에 대해 개인정보 파기계획을 수립하여
            파기합니다. 이천시시설관리공단은 파기 사유가 발생한 개인정보(또는 개인정보파일)를 선정하고,
            이천시시설관리공단의 개인정보 보호책임자의 승인을 받아 개인정보(또는 개인정보파일)를 파기합니다.<br />

            나. 파기방법<br />
            이천시시설관리공단은 전자적 파일 형태로 기록·저장된 개인정보는 기록을 재생할 수 없도록 파기하며, 종이 문서에
            기록·저장된 개인정보는 분쇄기로 분쇄하거나 소각하여 파기합니다.<br />
            <br /><br />
            8. 정보주체와 법정대리인의 권리·의무 및 행사방법<br />
            ① 정보주체는 이천시시설관리공단에 대해 언제든지 개인정보 열람·정정·삭제·처리정지 요구 등의 권리를 행사할 수
            있습니다.<br />
            ※ 만 14세 미만 아동에 관한 개인정보의 열람등 요구는 법정대리인이 직접 해야 하며, 만 14세 이상의 미성년자인
            정보주체는 정보주체의 개인정보에 관하여 미성년자 본인이 권리를 행사하거나 법정대리인을 통하여 권리를 행사할
            수도 있습니다.<br />

            ② 권리 행사는 이천시시설관리공단에 대해 「개인정보 보호법」 시행령 제41조 제1항에 따라 서면, 전자우편,
            모사전송(FAX.031-632-6681) 등을 통하여 하실 수 있으며, 이천시시설관리공단은 이에 대해 지체없이
            조치하겠습니다.<br />

            ③ 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수도 있습니다. 이 경우
            “개인정보 처리 방법에 관한 고시(제2020-7호)” 별지 11호 서식에 따른 위임장을 제출하셔야 합니다.<br />

            ④ 개인정보 열람 및 처리정지 요구는 「개인정보 보호법」 제35조 제4항, 제37조 제2항에 의하여 정보주체의 권리가
            제한될 수 있습니다.<br />

            ⑤ 개인정보의 정정 및 삭제 요구는 다른 법령에서 그 개인정보가 수집 대상으로 명시되어 있는 경우에는 그 삭제를
            요구할 수 없습니다.<br />

            ⑥ 이천시시설관리공단은 정보주체 권리에 따른 열람의 요구, 정정·삭제의 요구, 처리정지의 요구 시 열람 등 요구를
            한 자가 본인이거나 정당한 대리인인지를 확인합니다.<br /><br />
            <br /><br />
            9. 개인정보의 안전성 확보조치<br />
            이천시시설관리공단은 개인정보의 안전성 확보를 위해 다음과 같이 조치를 취하고 있습니다.<br />
            가. 관리적 조치: 내부관리계획 수립·시행, 개인정보보호책임자 지정, 정기적 직원 교육<br />
            나. 기술적 조치: 개인정보처리시스템 등의 접근권한 관리, 접근통제시스템 설치, 고유식별정보 등의 암호화,
            보안프로그램 설치<br />
            다. 물리적 조치: 전산실, 자료보관실 등의 접근통제<br />

            이천시시설관리공단은 개인정보의 안전성을 확보하기 위하여 법령에서 규정하고 있는 사항 이외에도 다음과 같은
            활동을 시행하고 있습니다.<br />
            1. 개인정보보호 활동: 개인정보보호 캠페인, 현장 점검 등 실시<br />
            1. 개인정보보호 인증 획득: 개인정보보호 우수 웹사이트(ePRIVACY) 인증<br />
            <br /><br />
            10. 개인정보 자동 수집 장치의 설치·운영 및 거부에 관한 사항<br />
            ① 이천시시설관리공단은 이용자에게 개별적인 맞춤서비스를 제공하기 위해 이용 정보를 저장하고 수시로 불러오는
            ‘쿠키(cookie)’를 사용합니다.<br />
            ② 쿠키는 웹사이트를 운영하는데 이용되는 서버(http)가 이용자의 컴퓨터 브라우저에게 보내는 소량의 정보이며
            이용자들의 PC 컴퓨터내의 하드디스크에 저장되기도 합니다.<br />
            가. 쿠키의 사용목적: 이용자가 방문한 각 서비스와 웹 사이트들에 대한 방문 및 이용형태, 인기 검색어, 보안접속
            여부 등을 파악하여 이용자에게 최적화된 정보 제공을 위해 사용됩니다.<br />
            나. 쿠키의 설치·운영 및 거부: 웹브라우저 상단의 도구>인터넷 옵션>개인정보 메뉴의 옵션 설정을 통해 쿠키
            저장을 거부 할 수 있습니다.<br />
            다. 쿠키 저장을 거부할 경우 맞춤형 서비스 이용에 어려움이 발생할 수 있습니다.<br />
            <br /><br />
            11. 개인정보의 추가적인 이용·제공 관련 판단 기준<br />
            ① 이천시시설관리공단은 개인정보보호법 제15조제3항 및 제17조제4항에 따라 개인정보보호법 시행령 제14조의2에
            따른 사항을 고려하여 정보주체의 동의 없이 개인정보를 추가적으로 이용·제공할 수 있습니다. 이에 따라,
            정보주체의 동의 없이 추가적인 이용·제공을 하기 위해서 다음과 같은 사항을 고려하였습니다.<br />
            가. 개인정보를 추가적으로 이용·제공하려는 목적이 당초 수집 목적과 관련성이 있는지 여부<br />
            나. 개인정보를 수집한 정황 또는 처리 관행에 비추어 볼 때 추가적인 이용·제공에 대한 예측 가능성이 있는지
            여부<br />
            다. 개인정보의 추가적인 이용·제공이 정보주체의 이익을 부당하게 침해하는지 여부<br />
            라. 가명처리 또는 암호화 등 안전성 확보에 필요한 조치를 하였는지 여부<br />
            <br /><br />
            12. 개인정보 보호책임자<br />
            ① 이천시시설관리공단은 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의
            불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.<br /><br />

            ▶ 개인정보 보호책임자<br />
            성명: 고주련<br />
            직책: 경영관리팀장<br />
            직급: 4급<br />
            연락처: TEL. 070-4941-1080 / FAX. 031)632-6681<br /><br />

            ▶ 개인정보 보호 담당부서 및 담당자 <br />
            부서명: 경영관리팀<br />
            담당자: 황은미 / 김아영<br />
            연락처: TEL. 070-4174-6568 / FAX. 031)632-6681<br /><br />

            ② 정보주체는 이천시시설관리공단의 서비스(또는 사업)를 이용하시면서 발생한 모든 개인정보보호 관련 문의,
            불만처리 피해구제 등에 관한 사항을 개인정보 보호책임자 및 담당부서로 문의할 수 있습니다.
            이천시시설관리공단은 정보주체의 문의에 대해 지체없이 답변 및 처리해드릴 것입니다.<br />
            <br /><br />
            13. 개인정보 열람청구<br />
            정보주체는 「개인정보 보호법」 제35조에 따른 개인정보의 열람 청구를 아래의 부서에 할 수 있습니다.<br />
            이천시시설관리공단은 정보주체의 개인정보 열람청구가 신속하게 처리되도록 노력하겠습니다.<br /><br />

            ▶ 개인정보 열람청구 접수·처리 부서<br />
            부서명: 경영관리팀<br />
            담당자: 황은미 <br />
            연락처: TEL. 070-4174-6568 / FAX. 031)632-6681<br />
            <br /><br />
            14. 권익침해 구제방법<br />
            정보주체는 개인정보침해로 인한 구제를 받기 위하여 개인정보분쟁조정위원회, 한국인터넷진흥원
            개인정보침해신고센터 등에 분쟁해결이나 상담 등을 신청할 수 있습니다. 이 밖에 기타 개인정보침해의 신고,
            상담에 대하여는 아래의 기관에 문의하시기 바랍니다.<br /><br />
            가. 개인정보분쟁조정위원회: (국번없이) 1833-6972 (www.kopico.go.kr)<br />
            나. 개인정보침해신고센터: (국번없이) 118 (privacy.kisa.or.kr)<br />
            다. 대검찰청: (국번없이) 1301 (www.spo.go.kr)<br />
            라. 경찰청: (국번없이) 182 (ecrm.cyber.go.kr)<br /><br />

            「개인정보 보호법」 제35조(개인정보의 열람), 제36조(개인정보의 정정·삭제), 제37조(개인정보의 처리정지 등)의
            규정에 의한 요구에 대하여 공공기관의 장이 행한 처분 또는 부작위로 인하여 권리 또는 이익의 침해를 받은 자는
            행정심판법이 정하는 바에 따라 행정심판을 청구할 수 있습니다.<br />
            ▶ 중앙행정심판위원회: (국번없이) 110 (www.simpan.go.kr)<br />
            <br /><br />
            15. 개인정보 관리수준진단 결과<br />
            ① 이천시시설관리공단은 정보주체의 개인정보를 안전하게 관리하기 위해 「개인정보 보호법」 제11조에 따라 매년
            개인정보보호위원회에서 실시하는 “공공기관 개인정보 관리수준진단”을 받고 있습니다.<br />

            ② 이천시시설관리공단은 2021년도 개인정보 관리수준진단 평가에서 ‘양호’ 등급을 획득하였습니다.<br />

            ③ 이천시시설관리공단은 2021년도 개인정보 관리수준진단 결과에 따라 다음과 같이 개선 조치하였습니다.<br />
            · 개인정보처리시스템 안전성 확보조치 등 개선<br />
            <br /><br />
            16. 영상정보처리기기 설치·운영<br />
            이천시시설관리공단은 아래와 같이 영상정보처리기기를 설치·운영하고 있습니다.<br /><br />

            ▶ 설치근거: 개인정보보호법 제25조 및 주차장법 시행규칙 제5조제1항제11호<br />
            ▶ CCTV 설치·운영 현황(2021.12.31.기준)<br /><br />
            연번 설치장소 설치목적 설치 대수 촬영내역 영상정보 관리 촬영범위 촬영시간 보유기간 삭제방법<br />
            1 노상주차장 안전사고 예방 90 주차면 24시간 30~90일 자동삭제<br />
            2 터미널 주차장 안전사고 예방 4 주차면 및 출입구 24시간 90일 자동삭제<br />
            3 중리천로주차장 안전사고 예방 11 주차면 및 출입구 24시간 90일 자동삭제<br />
            4 북샛말주차장 안전사고 예방 38 주차면 및 출입구 24시간 30일 자동삭제<br />
            5 서희청소년문화센터 주차장 시설물 관리 및 안전사고 예방 43 주차면 및 출입구 24시간 30일 자동삭제<br />
            6 택시쉼터 주차장 시설물 관리 및 안전사고 예방 32 주차면 및 출입구 24시간 30일 자동삭제<br />
            7 이천농업테마공원 시설물 관리 및 안전사고 예방 31 공원 외부 및 건물 내부 24시간 30일 자동삭제<br />
            8 이천시립 추모의 집 및 백사공설공원묘지 시설물 관리 및 안전사고 예방 8 시설물 내외부 24시간 30일
            자동삭제<br />
            9 이천시립 자연장지 시설물 관리 및 안전사고 예방 5 시설물 내외부 24시간 30일 자동삭제<br />
            10 교통약자 이동지원센터 특별교통수단 이용자의 안전 및 사고 발생 시 증거수집 24 차량 내외부 차량 운행중 2일
            자동삭제<br />
            <br /><br />
            ※ 보관장소: 각 설치장소 전산실 또는 사무실<br /><br />
            가. 관리책임자, 담당부서 및 영상정보에 대한 접근권한자<br />

            부 서 구 분 직위 및 성명 연락처<br />
            공공사업팀 (공영주차장) 관리책임자 박태훈 팀장 TEL. 070-4496-1824 FAX. 031-631-7152 접근권한자 이금순
            주임<br />
            복지여가팀 (이천농업테마공원) 관리책임자 정연민 팀장 TEL. 070-4941-1087 FAX. 031-632-6431 접근권한자 신서윤
            대리<br />
            장사시설팀 (추모의 집, 자연장지) 관리책임자 조양수 팀장 TEL. 070-4915-7254 FAX. 031-638-4145 접근권한자
            김동호 대리<br />
            교통사업팀 (이동지원센터) 관리책임자 이주헌 팀장 TEL. 070-4915-7251 FAX. 031-631-0461 접근권한자 최도현
            대리<br />
            <br /><br />
            나. 영상정보처리기기운영자의 영상정보 확인방법 및 장소<br />
            위 영상정보 관리책임자 또는 접근권한자에게 미리 연락하고 방문하시면 확인이 가능하며, 열람을 요구할 경우에는
            개인정보 열람·존재확인 청구서를 작성하여 담당부서에 제출하여야 합니다.<br />
            ※ 확인장소: 각 설치장소 전산실 또는 사무실<br /><br />

            다. 정보주체의 영상정보 열람 등 요구에 대한 조치<br />
            개인영상정보 열람·존재 확인 청구서로 신청하여야 하며, 정보주체 자신이 촬영된 경우 또는 명백히 정보주체의
            생명·신체·재산의 이익을 위해 필요한 경우에 한해 열람을 허용합니다.<br />
            단, 다음에 해당하는 경우에는 정보주체의 개인영상정보 열람 등 요구를 거부할 수 있습니다. 이 경우 10일 이내에
            서면 등으로 거부 사유를 정보주체에게 통지하도록 하겠습니다.<br />
            1) 범죄수사·공소유지·재판수행에 중대한 지장을 초래하는 경우<br />
            2) 개인영상정보의 보관 기간이 경과하여 파기한 경우<br />
            3) 기타 정보주체의 열람 등 요구를 거부할 만한 정당한 사유가 존재하는 경우<br /><br />

            라. 영상정보 보호를 위한 기술적·관리적 및 물리적 조치<br />
            이천시시설관리공단은 영상정보 보호를 위하여 내부관리계획 수립, 접근통제 및 접근권한 제한, 위·변조 방지를
            위한 처리기록 보관, 영상정보의 안전한 저장을 위한 보관시설 마련 및 잠금장치 설치 등 개인정보 처리방침을
            준용하여 운용하고 있습니다.<br /><br />

            마. 영상정보처리기기 안내판 설치<br />
            이천시시설관리공단은 위와 같이 영상정보처리기기를 설치·운영하고 있으며, 영상정보처리기기가 설치된 장소에
            안내판을 설치하여 고객 여러분이 영상정보 수집에 대하여 인식할 수 있도록 하고 있습니다.<br /><br />
            ▶ 안내판 기재내용: 설치목적, 촬영범위 및 시간, 담당부서, 책임자, 연락처<br />

            <br /><br />
            17. 개인정보 처리방침의 변경<br />
            ① 이 개인정보 처리방침은 2022. 12. 26.부터 적용됩니다.<br />
            ② 이전의 개인정보 처리방침(영상정보처리기기 설치 및 운영방침)은 아래에서 확인하실 수 있습니다.<br />
            <br /><br />
          </div>
        </article>
      </template>
      <template #button>
        <button class="btn closeBtn" @click="modalCloseBtn('personalModalShow')">
          <span class="hidden">닫기</span>
        </button>
      </template>
    </Modal>

    <Modal v-if="copyrightModalShow">
      <template #info> 저작권보호정책 </template>
      <template #content>
        <article>
          <div class="terms">
            <strong></strong>
            <p>
              이 정책의 목적은 이천시시설관리공단 홈페이지를 통하여 제공되는 정보가 정보출처를 밝히지 않고 무단 사용,
              변조, 상업적인 용도 등으로 사용되어 정보 이용자에게 피해를 끼치는 사례를 방지하는 데에 있습니다.
            </p>
            <p>
              본 홈페이지에서 제공하는 모든 자료는 저작권법에 의하여 보호받는 저작물로써 이용자는 아래의 저작권 보호
              정책을 준수하여야 합니다.
            </p>
            <p>
              이천시시설관리공단 홈페이지의 내용은 저작권법에 의한 보호를 받는 저작물로써 이에 대한 무단 복제 및 배포를
              원칙적으로 금지합니다.
            </p>
            <p>
              본 홈페이지에서 제공하는 자료로 수익을 얻거나 이에 상응하는 혜택을 누리고자 하는 경우에도 출처가
              이천시시설관리공단임을 반드시 명시하여야 하며, 본 홈페이지의 자료를 적법한 절차에 따른 인터넷 사이트에
              게재하는 경우에도 단순한 오류 정정 이외에 내용의 무단변경을 금지합니다.
            </p>
            <p>
              본 홈페이지에는 이천시시설관리공단이 저작재산권 전부를 소유하지 아니한 자료도 제공되고 있습니다. 이러한
              자료를 자유롭게 이용하기 위해서는 반드시 해당 저작권자의 허락을 받으셔야 합니다. 단순 열람 외에 무단 변경,
              복제, 배포, 개작 등의 이용은 금지되며 이를 위반할 경우 관련법에 의거 법적 처벌을 받을 수 있음을
              알려드립니다.
            </p>
          </div>
        </article>
      </template>
      <template #button>
        <button class="btn closeBtn" @click="modalCloseBtn('copyrightModalShow')">
          <span class="hidden">닫기</span>
        </button>
      </template>
    </Modal>

    <article class="quickMenu" :class="{ isActive }" @click="isActive = !isActive">
      <p>Quick</p>
      <div class="menuList">
        <ul>
          <li>
            <router-link to="/map">
              <i class="icon q-map"></i>
              <span>주차장 지도검색</span>
            </router-link>
          </li>
          <li>
            <router-link to="/lookup">
              <i class="icon q-prepay"></i>
              <span>주차요금 사전결제</span>
            </router-link>
          </li>
          <li>
            <router-link to="/lookupunpaid">
              <i class="icon q-unpaid"></i>
              <span>미납 주차요금</span>
            </router-link>
          </li>
        </ul>
        <ul>
          <li>
            <router-link to="/periodinfo">
              <i class="icon q-period"></i>
              <span>정기권 신청</span>
            </router-link>
          </li>
          <!-- <li>
            <router-link to="/advancepayment">
              <i class="icon q-fee"></i>
              <span>주차요금 간편조회</span>
            </router-link>
          </li> -->
        </ul>
      </div>
    </article>
    <div class="dimmed" @click="isActive = false"></div>
    <a href="javascript:void(0);" class="btnTop" @click="$vuetify.goTo('header')"
      ><span class="hidden">상단으로 올라가기</span></a
    >
  </footer>
</template>

<script>
import Modal from '../../components/PopupType1.vue';

export default {
  data() {
    return {
      modalShow: false,
      isActive: false,
      emailModalShow: false,
      personalModalShow: false,
      copyrightModalShow: false,
    };
  },
  components: {
    Modal,
  },
  methods: {
    // 외부사이트 오픈
    goExternalSite(url) {
      window.open(url, '_blank');
    },

    goFamilySite(e) {
      if (e.target.value != '' && e.target.value != null) {
        this.goExternalSite(e.target.value);
      }
    },

    eventStem(e) {
      switch (e.keyCode) {
        case 37:
          e.preventDefault();
          break;
        case 38:
          e.preventDefault();
          break;
        case 39:
          e.preventDefault();
          break;
        case 40:
          e.preventDefault();
          break;
      }
    },

    modalCloseBtn(e) {
      switch (e) {
        case 'emailModalShow':
          this.emailModalShow = false;
          break;
        case 'personalModalShow':
          this.personalModalShow = false;
          break;
        case 'copyrightModalShow':
          this.copyrightModalShow = false;
          break;
      }
    },

    modalShowBtn(e) {
      switch (e) {
        case 'emailModalShow':
          this.emailModalShow = true;
          break;
        case 'personalModalShow':
          this.personalModalShow = true;
          break;
        case 'copyrightModalShow':
          this.copyrightModalShow = true;
          break;
      }
    },
  },
};
</script>
